import DataTable from 'components/ui/DataTable/data-table';
import React, { FC, useState } from 'react';
import ViewIcon from '../../../assets/images/icons/view.png';
import EditIcon from '../../../assets/images/icons/edit.png';
import { FcUnlock } from 'react-icons/fc';
import { Cell } from 'react-table';
import { useListTraineeQuery } from 'redux/reducers/auth';
import PermissionWrapper from 'components/ui/PermissionWapper';
import { ActionType } from 'utils/action.type.enum';
import { ModuleCode } from 'utils/module.code.enum';
import { Button } from '@mui/material';
import ConfirmationModal from 'components/ui/ConfirmationModal/confirmation-modal';
import { useDeleteTrainee, useResetPasswordToDefault } from 'service/auth.query';
import { toast } from 'react-toastify';
import { FiDelete } from 'react-icons/fi';
import useToggle from 'hooks/useToggle';
import { TbTrash } from 'react-icons/tb';
import { useDecodeToken } from 'hooks/useStorage';

interface ITraineeDataTable {
  searchQuery: string;
  onEdit: (traineeData: any & { id: string; attendance_pin: string }) => void;
  onView: (traineeData: ITraineeInfo & { id: string; attendance_pin: string }) => void;
  onUnblock: (traineeData: ITraineeInfo & { id: string; attendance_pin: string }) => void;
}

export interface ITraineeData {
  id: number;

  first_name: string;
  middle_name: string;
  last_name: string;

  gender: string;

  user: [
    {
      id: number;
      email: string;
      status?: string; // optional if you want to use it
    }
  ];

  mobile_number: string;
  user_is_blocked: boolean;
  user_login_attempts_is_locked: boolean;

  attendance_pin: string;

  province_id: number;
  district_id: number;

  employee_sn: string;
  qualification: string;
  working_organization_name: string;
  passport_number: string;
  namc_or_nhpc: string;

  recommendation_letter: string;

  extra_fields: {
    program: any;
    locations: any;
    'mobile number': string;
    [key: string]: any; // in case API adds more dynamic fields
  };

  row_total?: number; // optional: present in your payload
}

export interface ITraineeInfo {
  first_name: string;
  middle_name: string;
  last_name: string;
  email: string;
  mobile_number: string;
  user__user_login_attempts__is_locked: boolean;
  userID: any;
}

const TraineeDataTable: FC<ITraineeDataTable> = ({ onEdit, onView, searchQuery, onUnblock }) => {
  const [pageNo, setPage] = useState(1);
const pageSize=10
  const [allDataList, setAllDataList] = useState(0);
  const [showConfirmation,setShowConfirmation]=useState<boolean>(false)
  const [selectedData,setSelectedData]=useState<any>()
  const [deleteModal, toggleDeleteModal] = useToggle(false);

  const handleTogggleConfirmation=()=>setShowConfirmation(prev=>!prev)
  const { data: userLists, isLoading, isSuccess } = useListTraineeQuery(    {

    searchQuery,
    pageNo,
    pageSize,
  });
  const totalUser = userLists?.data??[];
  const totalRows = totalUser && totalUser?.length > 0 ? userLists?.data?.[0]?.row_total : 0;


  const totalPages = Math.ceil(totalRows / 10);
  const canNext = pageNo < totalPages;
  const canPrevious = pageNo > 1;

    const decodedToken:any = useDecodeToken();
  
  const columns: any = [
    {
      Header: 'S.N',
      accessor: 'sn',
      Cell: (data: Cell<ITraineeData>) => {
        // return <>{data.row.index + 1}</>;
        setAllDataList(data.row.index + (pageNo - 1) * 10 + 1);
        return <>{pageNo === 1 ? data.row.index + 1 : data.row.index + (pageNo - 1) * 10 + 1}</>;
      }
    },
    {
      Header: '  First Name',
      accessor: 'first_name'
    },
    {
      Header: '  Middle Name',
      accessor: 'middle_name'
    },
    {
      Header: '  Last Name',
      accessor: 'last_name'
    },
    {
      Header: 'Email',
      accessor: 'user[0].email'
    },
    {
      Header: 'Attendance Pin',
      accessor: 'attendance_pin'
    },

    {
      Header: 'Phone',
      accessor: 'mobile_number'
    },
    {
      Header: 'Created By',
      accessor: 'user[0].created_by_name'
    },
    {
      Header: 'Actions',
      Cell: (cell: Cell<any & { id: string }>) => {
        return (
          <>
            <PermissionWrapper actionType={ActionType.CAN_VIEW}
              module_code={ModuleCode.TRAINEE_MANAGEMENT}
            >

              <img
                src={ViewIcon}
                style={{ cursor: 'pointer' }}
                onClick={() =>
                  onView({
                    id: cell.row.original.id,
                    userID: cell.row.original.user[0].id,
                    first_name: cell.row.original.first_name,
                    middle_name: cell.row.original.middle_name,
                    last_name: cell.row.original.last_name,
                    email: cell.row.original.user[0].email,
                    mobile_number: cell.row.original.mobile_number,
                    attendance_pin: cell.row.original.attendance_pin,
                    user__user_login_attempts__is_locked:
                      cell.row.original.user__user_login_attempts__is_locked
                  })
                }
              />
            </PermissionWrapper>
            <PermissionWrapper actionType={ActionType.CAN_UPDATE}
              module_code={ModuleCode.TRAINEE_MANAGEMENT}
            >

              <img
                src={EditIcon}
                style={{ cursor: 'pointer' }}
                className="m-2"
                onClick={() =>
                  onEdit({
                    id: cell.row.original.id,
                    userID: cell.row.original.user[0]?.id,

                    first_name: cell.row.original.first_name,
                    middle_name: cell.row.original.middle_name,
                    last_name: cell.row.original.last_name,
                    email: cell.row.original.user[0]?.email,
                    mobile_number: cell.row.original.mobile_number,
                    gender: cell.row.original.gender,

                    attendance_pin: cell.row.original.attendance_pin,
                    user_is_blocked: cell.row.original.user_is_blocked || false,
                    user_login_attempts_is_locked: cell.row.original.user_login_attempts_is_locked,

                    province_id: cell.row.original.province_id,
                    district_id: cell.row.original.district_id,

                    employee_sn: cell.row.original.employee_sn,
                    qualification: cell.row.original.qualification,
                    working_organization_name: cell.row.original.working_organization_name,
                    passport_number: cell.row.original.passport_number,
                    namc_or_nhpc: cell.row.original.namc_or_nhpc,

                    extra_fields: cell.row.original.extra_fields,
                    recommendation_letter: cell.row.original.recommendation_letter
                  })
                }
              />
            </PermissionWrapper>

            {cell.row.original.user__user_login_attempts__is_locked === true ? (
              <FcUnlock
                size={20}
                cursor={'pointer'}
                onClick={() =>
                  onUnblock({
                    id: cell.row.original.id,
                    userID: cell.row.original.user[0].id,
                    first_name: cell.row.original.first_name,
                    middle_name: cell.row.original.middle_name,
                    last_name: cell.row.original.last_name,
                    email: cell.row.original.user[0].email,
                    mobile_number: cell.row.original.mobile_number,
                    attendance_pin: cell.row.original.attendance_pin,
                    user__user_login_attempts__is_locked:
                      cell.row.original.user__user_login_attempts__is_locked
                  })
                }
              />
            ) : null}

      
            <TbTrash className='text-danger w-5 h-5' size={20} onClick={()=>{
              setSelectedData(cell.row?.original?.id)
              toggleDeleteModal()
              
            }}/>
            {decodedToken?.IsSuperUser=='True'?<Button
            onClick={()=>{
              setSelectedData(cell.row?.original?.user_id)
              handleTogggleConfirmation()

            }}
            >Reset</Button>:""}
          </>
        );
      }
    }
  ];


  const {mutate:resetPassword,isLoading:isResetting}=useResetPasswordToDefault()

  const {mutate:deleteTrainee,isLoading:isDeleting}=useDeleteTrainee()
  return (
    <>

          <ConfirmationModal
            isOpen={deleteModal}
            onClose={toggleDeleteModal}
            onConfirm={()=>{
               deleteTrainee(selectedData,{
                  onSuccess:(res)=>{
                    if(res?.data.code==200){
                      toast.success(res.data.message)
                      handleTogggleConfirmation()
                    }else{
                      toast.error(res?.data.message)

                    }
                  }
                })
            }}
            title="Delete Confirmation"
            isLoading={isDeleting}
          >
            <div className="p-3 text-center">
              <i className="ri-delete-bin-line text-danger display-5"></i>
              <h4 className="mt-3">Are you sure?</h4>
              <p className="text-muted">This action will permanently remove this MCQ.</p>
            </div>
          </ConfirmationModal>

    {
            <ConfirmationModal
              isOpen={showConfirmation}
              onClose={handleTogggleConfirmation}
              onConfirm={()=>{
                resetPassword(selectedData,{
                  onSuccess:(res)=>{
                    if(res?.data.code==200){
                      toast.success(res.data.message)
                      handleTogggleConfirmation()
                      setSelectedData(null)
                    }else{
                      toast.error(res?.data.message)

                    }
                  }
                })
              }}
              title="Reset password Confirmation"
              isLoading={isResetting}
            >
              <div className="p-3 text-center">
                <i className="ri-delete-bin-line text-danger display-5"></i>
                <h4 className="mt-3">Are you sure?</h4>
                <p className="text-muted">This action will reset password to default.</p>
              </div>
            </ConfirmationModal>
    }
    <DataTable
      columns={columns}
      data={totalUser || []}
      isLoading={isLoading}
      search={false}
      pagination={{
        canPrevious,
        canNext,
        prevPage: () => {
            if (canPrevious) {
              setPage((prev) => prev - 1);

            }
          },
          nextPage: () => {
            if (canNext) {
              setPage((prev) => prev + 1);
            }
          }
      }}
      />
      </>
  );
};

export default TraineeDataTable;
